// Text cleanup for anything a model wrote before it reaches a member.
//
// The system prompts already say never to use em dashes, but a prompt is a
// request, not a guarantee, and one made it into a live reveal. Prose the league
// actually reads has to be cleaned in code, not hoped about.

// Em dash, horizontal bar, and the "--" people type for one. En dashes are left
// alone on purpose: they are almost always a range ("2006-2010"), not a dash
// standing in for punctuation.
const DASHES = /\s*[—―]\s*|\s+--\s+/g;

export function cleanProse(input: string): string {
  if (!input) return input;
  return input
    .replace(DASHES, ", ")
    // A dash doing the work of a colon or a full stop can leave a doubled or
    // orphaned comma behind.
    .replace(/,\s*,+/g, ",")
    .replace(/\s+([,.!?;:])/g, "$1")
    .replace(/([,;:])\s*([.!?])/g, "$2")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/^[\s,;:]+/, "")
    .replace(/[\s,;:]+$/, "")
    .trim();
}

// Every member-visible string on a generated question.
export function cleanQuestionFields<T extends Record<string, any>>(q: T): T {
  const out: Record<string, any> = { ...q };
  for (const key of ["question_text", "option_a", "option_b", "option_c", "option_d", "reveal_context"]) {
    if (typeof out[key] === "string") out[key] = cleanProse(out[key]);
  }
  return out as T;
}
